// Card logo URLs - served from public folder
export const cardLogos = {
  Visa: "/assets/images/card/visa-card.svg",
  Mastercard: "/assets/images/card/mastercard-card.svg",
  JCB: "/assets/images/card/jcb-card.svg",
  AMEX: "/assets/images/card/amex-card.svg",
};
